import type { FC } from "react";
import { Link, useSearchParams } from "react-router-dom-v5-compat";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { TRIPS_PATH } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./MyTripPageHeader.module.scss";
export interface MyTripPageHeaderProps {
  className?: string;
  onClick?: () => void;
  linkText?: string;
}

export const MyTripPageHeader: FC<MyTripPageHeaderProps> = ({
  className,
  onClick,
  linkText,
}) => {
  const [block, cn] = useModuleBEM(styles, "MyTripPageHeader");
  const { t } = useI18nContext();
  const [searchParams] = useSearchParams();
  const fromPackage = searchParams.get("fromPackage");

  const resolvedTo =
    !onClick && !linkText && fromPackage
      ? `${TRIPS_PATH}/packages/${encodeURIComponent(fromPackage)}`
      : TRIPS_PATH;

  const resolvedLinkText =
    linkText ??
    (fromPackage
      ? t("packageTrips.backToPackage")
      : t("exchangeable.backToTrips"));

  const content = (
    <>
      <Icon iconName={IconNameEnum.circleChevronLeft} />
      <span className={cn("back-link-text")}>{resolvedLinkText}</span>
    </>
  );

  return (
    <div className={clsx(block, className)}>
      {onClick != null ? (
        <button className={cn("back-link")} onClick={onClick} type="button">
          {content}
        </button>
      ) : (
        <Link className={cn("back-link")} to={resolvedTo}>
          {content}
        </Link>
      )}
    </div>
  );
};
